import * as React from "react";
import { RadioGroup } from "../../../../react-core/Html/RadioGroup";
import { OrderType } from "../../../../Wrap/Constants/Enums/Domain/OrderType";

interface IValueSwitchProps {
    type: OrderType;
    onChange: (v: OrderType) => void;
    hasModel: boolean;
}

export const ValueSwitch = (props: IValueSwitchProps) => {
    const type = props.type || OrderType.Percentage;

    const orderTypeMap = {
        [OrderType.Percentage]: "%",
        [OrderType.Value]: "£",
    };

    let options = [OrderType.Percentage, OrderType.Value];

    return (
        <RadioGroup
            cssWrapper="value-type inline-block mt-10"
            options={options}
            getText={(o) => orderTypeMap[o]}
            label="Value type"
            onChange={(v) => props.onChange(v)}
            selected={type}
            radioLabelCss="radio-button pin-radio"
        />
    );
};
